export const useWidgetAlign = () => {
  const route = useRoute()

  // CloudFront strips the query string from the SSR cache key, so the cached
  // server render can carry another request's params. Bind `isMounted` to the
  // widget root `:key` so the subtree fully remounts on the client and rebuilds
  // from the real client URL — Vue keeps the server markup on a hydration
  // mismatch, so patching alone doesn't correct ?align / ?bgColor.
  const isMounted = ref(false)
  onMounted(() => {
    isMounted.value = true
  })

  const alignClass = () => {
    switch (route.query?.align) {
      case 'left':
        return 'justify-start'
      case 'right':
        return 'justify-end'
      default:
        return 'justify-center'
    }
  }

  const bgStyle = () =>
    route.query?.bgColor
      ? `background-color: #${route.query.bgColor}`
      : undefined

  return { alignClass, bgStyle, isMounted }
}
